import template from './radio-list.html';
import controller from './radio-list.controller';
import './radio-list.scss';

let radiolistComponent = {
    restrict: 'E',
    bindings: {
        items:'=',
        selected:'=',
        change:'&'
    },
    template,
    controller
};

export default radiolistComponent;



// WEBPACK FOOTER //
// ./src/app/common/radio-list/radio-list.component.js